import api from './api';

export const floorElementService = {
  getFloorElements: async (floorId = null) => {
    try {
      const query = floorId ? `?floorId=${floorId}` : '';
      const response = await api.get(`/api/business/floor-elements${query}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching floor elements:', error);
      throw error;
    }
  },

  getFloorElement: async (elementId) => {
    try {
      const response = await api.get(`/api/business/floor-elements/${elementId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching floor element:', error);
      throw error;
    }
  },

  createFloorElement: async (elementData) => {
    try {
      const response = await api.post('/api/business/floor-elements', elementData);
      return response.data;
    } catch (error) {
      console.error('Error creating floor element:', error);
      throw error;
    }
  },

  updateFloorElement: async (elementId, elementData) => {
    try {
      const response = await api.put(`/api/business/floor-elements/${elementId}`, elementData);
      return response.data;
    } catch (error) {
      console.error('Error updating floor element:', error);
      throw error;
    }
  },

  deleteFloorElement: async (elementId) => {
    try {
      const response = await api.delete(`/api/business/floor-elements/${elementId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting floor element:', error);
      throw error;
    }
  },
};

